import dashboardIcon from '@disy/cadenza-icons/dashboard.svg';
import projectIcon from '@disy/cadenza-icons/project.svg';
import viewIcon from '@disy/cadenza-icons/views.svg';
import externalLinkExtensionIcon from '@disy/cadenza-icons/visit-link.svg';
import workbookIcon from '@disy/cadenza-icons/workbook.svg';
import { assert } from '@disy/lib/custom-error';
import type { IconOptions } from '@disy/ui/icon';
import { type Icon, icon } from '@disy/ui/icon';

import { ItemType, isItemType } from 'cadenza/repository/model/item-type.gen';
import { WorksheetIconType } from 'cadenza/workbook/model/worksheet-icon-type';

import i18n from './type-icon.properties';

const NavigatorItemTypeValues = [
  'WORKBOOK',
  'WORKSHEET',
  'PROJECT',
  'EXTERNAL_LINK_EXTENSION',
  'MAP',
  'CHART',
  'TABLE',
] as const satisfies (ItemType | WorksheetIconType)[];

export type NavigatorItemType = (typeof NavigatorItemTypeValues)[number];

const ICONS: Partial<Record<ItemType, string>> = {
  WORKBOOK: workbookIcon,
  WORKSHEET: dashboardIcon,
  WORKBOOK_VIEW: viewIcon,
  PROJECT: projectIcon,
  EXTERNAL_LINK_EXTENSION: externalLinkExtensionIcon,
};

export const NavigatorItemType = {
  i18n: (type: NavigatorItemType) => (isItemType(type) ? ItemType.i18n(type) : i18n(`type.<${type}>`)),
  icon: (type: NavigatorItemType, withLabel?: true, options?: IconOptions): Icon => {
    assert(NavigatorItemType.includes(type), `Unsupported item type "${type}"`);
    return icon(isItemType(type) ? ICONS[type]! : WorksheetIconType.icon(type), {
      ...options,
      label: withLabel && NavigatorItemType.i18n(type),
    });
  },
  includes: (value: string): value is NavigatorItemType => NavigatorItemTypeValues.includes(value as NavigatorItemType),
} as const;
